import styled from 'styled-components';

export const SwitchDebt = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  border-radius: 30px;
  box-shadow: ${p => p.theme.modal.elevatedSoft};
  margin-bottom: 16px;
  overflow: hidden;
`;

export const SwitchDebtDivider = styled.div`
  align-self: stretch;
  flex-shrink: 0;
  width: 1px;
  margin: 0;
  background-color: ${p =>
    p.theme.ui.scheme === 'dark'
      ? 'rgba(148, 163, 184, 0.42)'
      : 'rgba(82, 85, 95, 0.28)'};
`;

export const TextDebt = styled.p`
  margin: 0;
  font-size: 11px;
  line-height: 1.5;
  letter-spacing: 0.04em;
  color: ${p => p.theme.colors.main.orangeMain};
`;

export const WrapIM = styled.button`
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 10px;
  border: none;
  box-sizing: border-box;
  border-radius: 30px 0px 0px 30px;
  background-color: ${({ active, theme }) =>
    active ? theme.colors.main.orangeLight : theme.colors.main.white};
  cursor: pointer;
  &:hover {
    background-color: ${p => p.theme.colors.main.orangeLight};
  }
`;

export const WrapI = styled(WrapIM)`
  border-radius: 0px 30px 30px 0px;
`;

export const RegWrap = styled.div`
  margin-top: 16px;
  border-radius: 30px;
  background-color: ${p => p.theme.colors.main.orangeLight};
  padding: 16px;
  margin-right: 24px;
`;

export const AddBtn = styled.button`
  background-color: ${p => p.theme.colors.main.white};
  border: 1px solid ${p => p.theme.colors.main.orangeLight};
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

export const AddPaymentWrap = styled.div`
  display: flex;
  align-items: center;
`;
export const SliderContainer = styled.div`
  position: relative;
  width: 100%;
  margin-top: 16px;
  margin-bottom: 32px;
`;

export const SliderInput = styled.input`
  -webkit-appearance: none;
  width: 100%;
  height: 8px;
  border-radius: 5px;
  background: ${({ theme }) => theme.colors.main.orangeLight};
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.main.orangeMain};
    cursor: pointer;
  }

  &::-moz-range-thumb {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.text.greenMain};
    cursor: pointer;
  }
`;

export const SliderValue = styled.div`
  position: absolute;
  top: 25px;
  left: ${props => props.value}%;
  transform: translateX(-50%);
  background: transparent;
  color: ${({ theme }) => theme.colors.main.orangeMain};
  padding: 5px 10px;
  border-radius: 5px;
`;
export const SectorLine = styled.div`
  height: 4px;
  border-radius: 32px;
  background-color: ${props => props.color};
  border-color: transparent;
  margin-right: 2px;
  &:last-child {
    margin-right: 0;
  }
`;
